export const ru = {
    'show-all-text': 'Показать все трансляции'
};
